import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { HttpParams } from '@angular/common/http';

import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { MrnItemResultsViewModel, TPreduaMantenimientoViewModel, FilterSearchingMrnViewModel } from './mrn.types';
import { MrnService } from './mrn.service';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-mrn-list',
    templateUrl: './mrn-list.component.html',
})
export class MrnListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;
    resultMrn: MrnItemResultsViewModel;
    cols: any[];
    visibilitySpinner = false;
    public isCollapsed = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private mrnService: MrnService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultMrn = new MrnItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            //{ field: 'Id', header: 'Id', display: 'none' },
            //{ field: 'Image', header: '' },
            { field: 'Mrn', header: 'MRN' },
            { field: 'FechaPresentacion', header: 'Fecha Presentación' },
            { field: 'IdPifDescripcion', header: 'Punto Inspección' },
        ];

        this.form = this.fb.group({
            Mrn: ['', Validators.required],
        });

        this.loadBack();
    }

    loadBack() {
        if (this.mrnService.currentFilterMrn.Mrn != '') {
            this.form.patchValue({
                Mrn: this.mrnService.currentFilterMrn.Mrn,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        this.removeValidators('Mrn');
        this.addValidator('Mrn', Validators.required);

        if (this.isFieldInvalidNoSubmit('Mrn', 'required')) {
            return;
        }

        this.removeValidators('Mrn');

        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        this.mrnService.currentFilterMrn.Mrn = this.form.value.Mrn;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc = 0, orderBy = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);

        params = params.append('mrn', this.form.value.Mrn);

        this.loading = true;
        this.mrnService.getMrnPagedByFilter(params).subscribe(result => {
            this.resultMrn = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;

        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            Mrn: '',
        });
        this.searchingButton = false;
        this.isCollapsed = false;
    }

    onEdit(item: TPreduaMantenimientoViewModel) {
        this.router.navigate(['/mantenimiento/general/mrn/edit', item.Mrn]);
    }

    CreateModel() {
        let model: FilterSearchingMrnViewModel = new FilterSearchingMrnViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.mrnService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }
}
